import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as _ from 'lodash';
import { CookieService } from 'ngx-cookie-service';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import { CapabilityEngineService } from '../capabilityEngine.service';
import { ChangePasswordComponent } from '../change-password/change-password.component';
import { Constants } from '../constants';
import { RedirectService } from '../redirect/redirect.service';
import { SwitchMessageComponent } from '../switch-message/switch-message.component';
import { LandingService } from './landing.service';
declare var $: any;

@Component({
    selector: 'app-landing',
    templateUrl: './landing.component.html',
    styleUrls: ['./landing.component.scss']
})
export class LandingComponent implements OnInit {
    isSupervisor: Boolean = false;
    isAdmin: Boolean = false;
    isRbaSales: Boolean = false;
    teamName: string;
    userRole: string;
    userName: string;
    userEmail: string;
    currentPage: string;
    isHazardForm: Boolean;
    version: string;
    buildNumber: string;
    showToaster: Boolean = false;
    switchTeamusers: any;
    authType: any;
    hazardTemplateId;
    formType: string = '';
    constructor(
        private _router: Router,
        private _route: ActivatedRoute,
        private _capabilityEngineService: CapabilityEngineService,
        private _landingService: LandingService,
        private _redirectService: RedirectService,
        private _activatedRoute: ActivatedRoute,
        private constants: Constants,
        private _cookieService: CookieService,
        private modalService: NgbModal
    ) {
        this._router.events
            .filter(event => event instanceof NavigationEnd)
            .map(() => this._route)
            .map(route => {
                while (route.firstChild) route = route.firstChild;
                return route;
            })
            .filter(route => route.outlet === 'primary')
            .mergeMap(route => route.data)
            .subscribe(event => {
                
                this._activatedRoute.queryParams.subscribe((response) => {
                    if(!_.isEmpty(response) && !_.isEmpty(response['formType'])) {
                        this.formType = response['formType'];
                    } else {
                        this.formType = undefined;
                    }
                })
                this.currentPage = event.currentPage;
                if (this._activatedRoute.snapshot.queryParams.currentPage) {
                    this.currentPage = this._activatedRoute.snapshot.queryParams.currentPage;
                }
            });
            if(localStorage.getItem('hazardTemplateId')) {
                this.hazardTemplateId = localStorage.getItem('hazardTemplateId')
            } else {
                this.hazardTemplateId = this.constants.HAZARD_TEMPLATE_ID
            }
    }

    ngOnInit() {
        this.version = this.constants.VERSION_NUMBER;
        this.buildNumber = this.constants.BUILD_NUMBER;
        this.switchTeamusers = JSON.parse(localStorage.getItem('teams'));
        this.teamName = localStorage.getItem('teamName');
        this.userRole = localStorage.getItem('userRole');
        this.authType = localStorage.getItem('authType');
        if (this.userRole === 'supervisor') {
            this.isSupervisor = true;
        }
        if (this.userRole === 'webAdmin') {
            this.isAdmin = true;
        }
        if (this.userRole === 'rbaAdmin') {
            this.isRbaSales = true;
        }
        // this.userName = localStorage.getItem('userName');
        this.userEmail = localStorage.getItem('userEmail');
        console.log(this.userEmail);
    }

    canPerform(data) {
        return this._capabilityEngineService.canPerform(data);
    }
    isFormhound() {
        return this._capabilityEngineService.isFormhound();
    }
    // switchUsers
    switchUsers() {
        let modalOptions: any = {
            size: 'md',
            centered: true,
            windowClass: 'md-dialog-small',
        };
        const modalRef = this.modalService.open(
            SwitchMessageComponent,
            modalOptions
        );
    }
    logout() {
        localStorage.clear();
        this.isSupervisor = false;
        this.isAdmin = false;
        this.isRbaSales = false;
        this._router.navigateByUrl('/signin');
        return this._landingService.logout().subscribe(
            res => {
                console.log(res);
                localStorage.clear();
                this.isSupervisor = false;
                this.isAdmin = false;
                this.isRbaSales = false;
                this._capabilityEngineService.clearCapabilities();
                this._router.navigateByUrl('/signin');
            },
            err => {
                console.log(err);
            }
        );
    }
    teamDetailsPage() {
        // window.location.reload();
        this._router.navigateByUrl('/teamprofile');
    }

    toaster() {
        // console.log('hello world', this.userEmail);
        this.showToaster = true;
        setTimeout(() => {
            console.log('setTimeout');
            this.showToaster = false;
        }, 3000);
    }

    updateTeamName() {
        this.teamName = localStorage.getItem('teamName');
     }

    // changePassword(){
    //     const modalRef = this.modalService.open(changePasswordService, {
    //             //     keyboard: false,
    //             //    backdrop: 'static'
    //            });    }

    changePassword = () => {
        let modalOptions: any = {
            windowClass: 'md-dialog-medium',
        };
        const modalRef = this.modalService.open(ChangePasswordComponent,modalOptions);
    }

    getFirstLetterString(name) {
        let result = '';
        let splitArray = name.split(' ');
        if (name.length === 1) {
            result = name;
        } else if (splitArray.length === 1) {
            result = splitArray[0][0] + splitArray[0][1];
        } else {
            _.forEach(splitArray, function(word) {
                result = result.concat(word[0]);
            });
        }
        return result.substring(0, 2);
    }
    getActionTemplateId() {
        if(localStorage.getItem("actionTemplateId")) {
          return localStorage.getItem("actionTemplateId")
        } else {
          return this.constants.ACTION_TEMPLATE_ID
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/landing/landing.component.ts